import mediaQueries from "@tesla/design-system-tokens/dist/media.js";
const matchCustomMediaQuery = (query) => {
  const defaultMatch = {
    addEventListener: null,
    matches: false,
    media: query,
    removeEventListener: null
  };
  if (typeof window !== "undefined") {
    return window.matchMedia?.(query) ?? defaultMatch;
  }
  return defaultMatch;
};
const matchMediaQuery = (query) => {
  return matchCustomMediaQuery(mediaQueries[query]);
};
const isMedia = (query) => matchMediaQuery(query).matches;
const isPhoneOnly = () => isMedia("phone-only");
const isTabletPortraitOnly = () => isMedia("tablet-portrait-only");
const isTabletPortraitUp = () => isMedia("tablet-portrait-up");
const isTabletLandscapeOnly = () => isMedia("tablet-landscape-only");
const isTabletLandscapeUp = () => isMedia("tablet-landscape-up");
const isDesktopOnly = () => isMedia("desktop-only");
const isDesktopUp = () => isMedia("desktop-up");
const isDesktopLargeUp = () => isMedia("desktop-large-up");
const isDensity2x = () => isMedia("density--2x");
const isDensity3x = () => isMedia("density--3x");
const isDensity4x = () => isMedia("density--4x");
export {
  isDensity2x,
  isDensity3x,
  isDensity4x,
  isDesktopLargeUp,
  isDesktopOnly,
  isDesktopUp,
  isMedia,
  isPhoneOnly,
  isTabletLandscapeOnly,
  isTabletLandscapeUp,
  isTabletPortraitOnly,
  isTabletPortraitUp,
  matchCustomMediaQuery,
  matchMediaQuery
};
